export default url => /^http/.test(url)
